<template>
    <div class="info-list d-flex flex-column">
        <ul>
            <li v-for="(item, i) in items" :key="i">
                <InfoListItem :item="item"></InfoListItem>
            </li>
        </ul>
    </div>
</template>
  
<script setup>
import InfoListItem from "../info/InfoListItem.vue";

const props = defineProps({
    items: Object
});

</script>

<style lang="scss">
@import '@/styles/variables.scss';

.info-list {
    ul {
        list-style-type: none;

        >li {
            margin: 3px 0;
        }
    }
}
</style>
  